import React from 'react';

const ProgressDetails = ({ talents }) => {
  
  let interestedCount = 0;
  let invitedCount = 0;
  let totalTalents = 0;

  if (Array.isArray(talents) && talents.length > 0) {
    totalTalents = talents.length;
    talents.forEach(talent => {
      if (talent && !!talent.is_interested) {
        interestedCount++;
      }
      if (talent && !!talent.is_invited ) {
        invitedCount++;
      }
    });
  } else {
    // Handle cases where talents is undefined, null, or empty
    // You can set them to '0', 'N/A', or any other placeholder
    interestedCount = 'N/A';
    invitedCount = 'N/A';
    totalTalents = 'N/A';
  }

  return (
    <div>
      <h2 className='text-xl lg:text-2xl font-semibold leading-8 mb-3.5'>
        Progress Details
      </h2>
      <div className='flex flex-row gap-[30px] flex-wrap'>
        <div className='flex items-center gap-9'>
          <h3 className='text-xl font-semibold'>Talent Response:</h3>
          <p className='lg:text-lg text-muted-foreground'>{interestedCount}/{totalTalents}</p>
        </div>
        <div className='flex items-center gap-9'>
          <h3 className='text-xl font-semibold'>Interview Invitations:</h3>
          <p className='lg:text-lg text-muted-foreground'>{invitedCount}</p>
        </div>
        <div className='flex items-center gap-9'>
          <h3 className='text-xl font-semibold'>Gig Status</h3>
          <p className='lg:text-lg text-muted-foreground'>N/A</p>
        </div>
      </div>
    </div>
  );
};

export default ProgressDetails;
